import { call, put } from 'redux-saga/effects';
import { CREATE_EDGE } from '@control-front-end/common/constants/graphActors';
import { getGraphEls, makeGraphModels } from './graphHelpers';

/**
 * Воссоздать такие же связи, но с другим edgeTypeId
 */
export function* createNewEdges(edges, edgeTypeId) {
  for (const i of edges) {
    const { laIdSource, laIdTarget, source, target, name } = i;
    const subscribeBalances = false;
    yield put({
      type: CREATE_EDGE.REQUEST,
      payload: {
        source,
        target,
        laIdSource,
        laIdTarget,
        edgeTypeId,
        name,
        subscribeBalances,
      },
    });
  }
}

/**
 * Рекурсивный поиск не группирующего родительского актора
 */
function* recursiveFindRealNode(node, nodes, edges) {
  const incomersE = edges.filter((e) => e.data.target === node.id);
  const incomersN = nodes.filter((n) =>
    incomersE.find((j) => n.id === j.data.source)
  );
  const parentNode = incomersN[0];
  if (!parentNode.data.isMore) return parentNode;
  return yield call(recursiveFindRealNode, parentNode, nodes, edges);
}

/**
 * Рекурсивно добавить все дочерние акторы
 */
export function* addAllDescendants(moreNode, { nodes, edges }) {
  const copyNodes = yield call(getGraphEls, 'nodes');
  const copyEdges = yield call(getGraphEls, 'edges');
  const outgoersE = copyEdges.filter((e) => e.data.source === moreNode.id);
  const outgoersN = copyNodes.filter((n) =>
    outgoersE.find((j) => n.id === j.data.target)
  );
  edges.push(...outgoersE.map((e) => e.data));
  nodes.push(...outgoersN.map((n) => n.data));
  for (const n of outgoersN) {
    if (!n.data.isMore) continue;
    addAllDescendants(n, { nodes, edges });
  }
}

/**
 * Свернуть сгруппированные акторы в реальный граф
 */
export function* removeGroupTplActors({ nodes = [], edges = [] }) {
  const graphNodes = yield call(getGraphEls, 'nodes');
  const graphEdges = yield call(getGraphEls, 'edges');
  edges = JSON.parse(JSON.stringify(edges));
  nodes = JSON.parse(JSON.stringify(nodes));
  for (const i of edges) {
    if (i.realSourceActorId) {
      i.sourceActorId = i.realSourceActorId;
      i.source = i.realSourceActorId;
      delete i.realSourceActorId;
    } else if (i.source.indexOf('_nodeMore') !== -1) {
      const sourceNode = graphNodes.find((n) => n.id === i.source);
      const realSourceNode = sourceNode.data.isMore
        ? yield call(recursiveFindRealNode, sourceNode, graphNodes, graphEdges)
        : sourceNode;
      i.sourceActorId = realSourceNode.data.actorId;
      i.source = realSourceNode.data.actorId;
    }
  }
  const copyNodes = nodes.filter((i) => !i.isMore);
  const copyEdges = edges.filter((i) => !i.isMore);
  return { nodes: copyNodes, edges: copyEdges };
}

/**
 * Элементы графа после вставки
 */
export function* getGraphElsAfterPaste({
  nodes,
  edges,
  typeLayer,
  sameEdgeType,
  isTree,
}) {
  const copyNodes = yield call(getGraphEls, 'nodes');
  const { nodes: graphNodes, edges: graphEdges } = yield call(makeGraphModels, {
    nodes,
    edges,
    isTree,
  });
  if (typeLayer === 'layers') {
    copyNodes.push(...graphNodes);
  } else {
    const noDuplicateNodes = graphNodes.filter(
      (n) => !copyNodes.find((i) => i.id === n.id)
    );
    copyNodes.push(...noDuplicateNodes);
  }
  if (!sameEdgeType) return { nodes: copyNodes };
  const copyEdges = yield call(getGraphEls, 'edges');
  if (typeLayer === 'actors') {
    const hiddenEdges = yield getGraphEls('hiddenEdges');
    const visibleEdges = graphEdges.filter(
      (i) => !hiddenEdges.includes(i.data.edgeId)
    );
    copyEdges.push(...visibleEdges);
  } else if (typeLayer === 'layers') {
    copyEdges.push(...graphEdges);
  }
  return { nodes: copyNodes, edges: copyEdges };
}
